import { MUICircularProgress, MUIGrid } from "@cobee/cobee-ui";

export default function CenterLoader(): JSX.Element {
  return (
    <MUIGrid p={8} container item xs={12} justifyContent="center">
      <MUICircularProgress color="secondary" />
    </MUIGrid>
  );
}
